export default __webpack_public_path__ + "static/media/18.c204b252.jpg";